<template>
  <div class="powerBankOrder">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.orderId" placeholder="订单号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.payOrderId" placeholder="支付订单号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.usPhone" placeholder="手机号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="request.state" clearable placeholder="订单状态" style="width:200px">
            <el-option v-for="(item,index) in global.order_state" :key="index" :label="item.message" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-input v-model="request.thirdOrderId" placeholder="订单交易明细号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.orderServiceId" placeholder="服务单号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.nickName" placeholder="昵称" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="request.rentTime" clearable = true placeholder="租借时长" style="width:200px">
            <el-option v-for="(item,index) in global.order_search_time" :key="index" :label="item.message" :value="item.code"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item><el-input v-model="request.powerBankId" placeholder="充电宝编号" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-date-picker v-model="time" :append-to-body="false" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="chooseTime"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getOrderPage()">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.orderData"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                style="margin:auto;width:calc(100% - 30px)" height="730" border
                :row-style="rowStyle"
                :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="订单号" width="220" align="center" prop="orderId"></el-table-column>
        <el-table-column label="支付订单号" width="300" prop="payOrderId" align="center"></el-table-column>
        <el-table-column label="租借时间" width="200" align="center" prop="rentTime"></el-table-column>
        <el-table-column label="归还时间" width="200" align="center" prop="returnTime"></el-table-column>
        <el-table-column label="支付时间" width="200" align="center" prop="payTime"></el-table-column>
        <el-table-column label="订单单价" width="150" align="center" prop="rentPrice"></el-table-column>
        <el-table-column label="租借时长" width="250" align="center" prop="rentDuration"></el-table-column>
        <el-table-column label="订单金额" width="100" align="center" prop="orderMoney"></el-table-column>
        <el-table-column label="最终金额" width="100" align="center" prop="finalMoney"></el-table-column>
        <el-table-column label="订单来源" width="100" align="center" prop="orderSource"></el-table-column>
        <el-table-column label="支付方式" width="200" align="center" prop="transactionType"></el-table-column>
        <el-table-column label="订单状态" width="100" align="center" prop="orderState"></el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button @click="showOrderDetail(scope.row.orderId)" type="warning" size="small" plain>详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    <order-detail v-if="detailDialog" ref="orderDetail"></order-detail>
  </div>
</template>

<script>
import {getAllOrder} from '../../api/oder/powerbankorder.js'
import orderDetail from './orderDetail.vue'
import {formatDate} from "../../utils/date";

export default {
  name: 'PowerBankOrder',
  components: {
    orderDetail
  },
  data() {
    return {
      titleImg: require("../../../static/image/relation/daili-dlxq.png"),
      request: {
        orderId: '',
        payOrderId: '',
        orderServiceId: '',
        thirdOrderId: '',
        usPhone: '',
        state: '',
        nickName: '',
        rentTime: '',
        startTime: '',
        endTime: '',
        powerBankId: '',
        current: '',
        size: ''
      },
      time: '',
      global:'',
      loading: false,
      query: {current: 1, size: 15},
      response: {orderData: [], total: 0},
      detailDialog: false,
    }
  },
  methods: {
    /**
     * 时间选择触发事件
     */
    chooseTime(events){
      this.request.startTime = events[0];
      this.request.endTime = events[1];
    },

    /**
     * 获取订单列表数据
     */
    getOrderPage() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllOrder(this.request).then(result => {
        this.response.orderData = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getOrderPage()
    },

    /**
     * 显示订单详情
     */
    showOrderDetail(value) {
      this.detailDialog = true;
      this.$nextTick(() =>{
        this.$refs.orderDetail.init(value);
      })
    },

    /**
     *  重置
     */
    reset() {
      this.request.orderId = '';
      this.request.payOrderId = '';
      this.request.orderServiceId = '';
      this.request.thirdOrderId = '';
      this.request.usPhone = '';
      this.request.state = '';
      this.request.nickName = '';
      this.request.startTime = '';
      this.request.endTime = '';
      this.request.rentTime = '';
      this.request.powerBankId = '';
      this.request.current = 1;
      this.request.size = 10;
      this.getOrderPage();
    },
    rowStyle({row, column, rowIndex, columnIndex}){
      //设置表格每行间隔颜色
      if(row.remarkFlag){
        return {height: '0.3%',background:'#8A2BE2',color:'#000'}
      }else{
        switch (row.discountType) {
          case "usVip":{
            return {height: '0.3%',background:'#00FF00',color:'#000'}
          }
          case "coupon":{
            return {height: '0.3%',background:'#03A89E',color:'#000'}
          }
          case "bsVip":{
            return {height: '0.3%',background:'#228B22',color:'#000'}
          }
        }
      }
    }
  },
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"))
    this.getOrderPage();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
    }
  }
}
</script>
<style scoped>
.powerBankOrder {
  width: 100%;
  height: 100%;
}

.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ordermanagement/powerbankorder.vue